module.exports = __webpack_public_path__ + "assets/img/JT.3b7fc925.png";